<template>
    <div class="mt-2">
        <div class="flex gap-2 flex-col items-start" v-show="props.tags">
            <span v-for="(tag, index) in props.tags" :key="index" :class="`tag tag--${tag.key}`">{{ tag.label }}</span>
        </div>
        <!-- <span v-show="props.soldOut" class="tag sold-out">Sold out</span> -->
    </div>
</template>

<script setup>
const props = defineProps({
    tags: {
        type: Array,
        required: true,
    },
    soldOut: {
        type: Boolean,
        default: false,
    },
});
</script>
